import React from 'react';
import { Heading, Box, Body, SimpleGrid, Divider } from '@hover/blueprint';
import { PRICING_TO_MATCH_PROPERTY } from '../../../constants';
import { IPricingToMatch } from '../../../interfaces/IPricingToMatch';
import PricingTooltip from '../plans-and-pricing/PricingTooltip';

const PricingToMatchDesktopAndTablet: React.FC = () => (
  <Box w="100%" flexDir="column" d={{ base: 'none', tablet: 'flex' }}>
    <Heading
      marginBottom={{ tablet: '56px', desktop: 1000 }}
      size={{ tablet: 600, desktop: 700 }}
      isLight
      mx="auto"
    >
      Pricing to match each property
    </Heading>
    <SimpleGrid columns={4} spacing={{ tablet: 400, desktop: 600 }}>
      <Box
        alignItems="flex-end"
        mb={600}
        h={{ tablet: '257px', desktop: '332px' }}
      >
        <PricingTooltip
          marginBottom={0}
          maxW="245px"
          mr={600}
          tooltip={{
            title:
              'You pay per property based on the facet count of the roof. ',
            tooltip:
              '"A facet is a single, uninterrupted plane on the roof. Each separate flat section counts as a facet."',
          }}
        />
      </Box>
      {PRICING_TO_MATCH_PROPERTY.map((match: IPricingToMatch) => (
        <Box key={match.id} pb={600} bg="brandTan.100" flexDir="column">
          <Box
            maxW="276px"
            h={{ tablet: '257px', desktop: '332px' }}
            pt={400}
            bg="brandBrown.100"
            shadow="distance300"
            px={{ tablet: 200, desktop: 500 }}
            flexDir="column"
            alignItems="center"
            borderRadius="8px 8px 0 0"
          >
            <Body isBold size={600} marginBottom={100} color="neutral.600">
              {match.title}
            </Body>
            <Body isBold size={400} marginBottom={100}>
              {match.facets}
            </Body>
            <Box my="auto">{match.image}</Box>
          </Box>
        </Box>
      ))}
    </SimpleGrid>
    <Divider borderColor="neutral.400" />
    <SimpleGrid
      columns={4}
      spacing={{ tablet: 400, desktop: 600 }}
      alignItems="center"
    >
      <Heading marginTop="30px" marginBottom="30px" size={500}>
        ROOF-ONLY
      </Heading>
      {PRICING_TO_MATCH_PROPERTY.map((match: IPricingToMatch) => (
        <Box bg="brandTan.100" justifyContent="center" key={match.id}>
          <Heading size={600} marginTop="30px" marginBottom="30px">
            ${match.roofOnly}
          </Heading>
        </Box>
      ))}
    </SimpleGrid>
    <Divider borderColor="neutral.400" />
    <SimpleGrid
      alignItems="center"
      columns={4}
      spacing={{ tablet: 400, desktop: 600 }}
    >
      <Heading
        alignItems="center"
        marginTop="30px"
        marginBottom="30px"
        size={500}
      >
        COMPLETE
      </Heading>
      {PRICING_TO_MATCH_PROPERTY.map((match: IPricingToMatch) => (
        <Box
          bg="brandTan.100"
          justifyContent="center"
          key={match.id}
          alignItems="center"
        >
          <Heading size={600} marginTop="30px" marginBottom="30px">
            ${match.complete}
          </Heading>
        </Box>
      ))}
    </SimpleGrid>
    <Divider borderColor="neutral.400" />
  </Box>
);

export default PricingToMatchDesktopAndTablet;
